import React from "react";
import { kreieren } from "@/api/kreierenClient";

// Fehler-Fang (25.08.2026): Ein Absturz im Studio zeigte nur Schwarz — niemand konnte lesen, was
// kaputt ist. Ab jetzt: Meldung + Stack auf dem Bildschirm UND als Datei auf Dropbox
// (Studio/_ui_fehler.json), damit der Toolserver sie ohne Browser lesen kann.
export default class FehlerFang extends React.Component {
  constructor(props) { super(props); this.state = { fehler: null }; }
  static getDerivedStateFromError(e) { return { fehler: e }; }
  componentDidCatch(e, info) {
    try {
      const body = { time: new Date().toISOString(), message: String(e?.message || e), stack: String(e?.stack || "").slice(0, 4000), component: String(info?.componentStack || "").slice(0, 4000), url: location.href, ua: navigator.userAgent };
      kreieren.saveDoc("/Content/FUNKENSTEIN/Studio/_ui_fehler.json", JSON.stringify(body, null, 2)).catch(() => {});
    } catch (x) { /* nichts — der Fang darf selbst nie fallen */ }
  }
  render() {
    if (!this.state.fehler) return this.props.children;
    const e = this.state.fehler;
    return (
      <div style={{ padding: 24, color: "#fff", background: "#0b0d12", minHeight: "100vh", fontFamily: "monospace" }}>
        <div style={{ fontSize: 14, marginBottom: 8 }}>⚠️ Die Oberfläche ist abgestürzt — die Meldung liegt auch in Studio/_ui_fehler.json.</div>
        <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, color: "#f88" }}>{String(e?.message || e)}</pre>
        <pre style={{ whiteSpace: "pre-wrap", fontSize: 10, color: "#999" }}>{String(e?.stack || "").slice(0, 1500)}</pre>
        <button onClick={() => location.reload()} style={{ marginTop: 12, padding: "6px 12px" }}>Neu laden</button>
      </div>
    );
  }
}
